import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { colors } from '../../healtheraComponents'

const Badge = ({ text, ...styleVariants }) => <Tag {...styleVariants}>{text}</Tag>

Badge.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Badge

export const Tag = styled.div`
&&
{
  border: 2px solid;
  font-size: 15px;
  font-weight: 600;
  padding: 5px 15px;
  width: fit-content;
  
  && + * {
    margin-left: 10px;
  }
  
  ${props =>
    props.green &&
    css`
      color: ${colors.HEALTHERA_GREEN};
    `}
  
  ${props =>
    props.orange &&
    css`
      color: ${colors.HEALTHERA_ORANGE};
    `}
  
  ${props =>
    props.left &&
    css`
      border-radius: 50px 20px 20px 50px;
      padding-left: 20px;
    `}
  
  ${props =>
    props.right &&
    css`
      border-radius: 20px 50px 50px 20px;
      padding-right: 20px;
    `}
}
`
